import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultaHistorialControl_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultaSolicitudDeServicioRest",
    rutaEndPoint: "/EnterpriseServices/Sel/ConsultaSolicitudDeServicioRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}


//entrada
export interface ConsultaHistorialControl_entrada {
    ConsultaSolicitudDeServicioProcessRequest: ConsultaSolicitudDeServicioProcessRequest;
    EBMHeaderRequest:                          EBMHeaderRequest;
}

export function builtConsultaHistorialControlEntrada( l_ConsultaSolicitudDeServicioProcessRequest: ConsultaSolicitudDeServicioProcessRequest,
                                                       l_EBMHeaderRequest: EBMHeaderRequest ) {
    var retorno: ConsultaHistorialControl_entrada = {
        ConsultaSolicitudDeServicioProcessRequest: l_ConsultaSolicitudDeServicioProcessRequest,
        EBMHeaderRequest: l_EBMHeaderRequest
    };
  
    return retorno;
  }

export interface ConsultaSolicitudDeServicioProcessRequest {
    AreaSS:    string;
    RowId:     string;
    SubAreaSS: string;
}

export function builtConsultaSolicitudDeServicioProcessRequest ( l_AreaSS: string, l_RowId: string, l_SubAreaSS: string){
    var retorno: ConsultaSolicitudDeServicioProcessRequest = {
        AreaSS: l_AreaSS, 
        RowId: l_RowId,
        SubAreaSS: l_SubAreaSS};

    return retorno;
}

export interface EBMHeaderRequest {
    Operacion:     string;
    ParametroList: ParametroList;
    SeguridadList: SeguridadList;
    SistemaOrigen: string;
}

export function builtEBMHeaderRequest( l_Operacion: string, l_ParametroList: ParametroList, l_SeguridadList: SeguridadList, l_SistemaOrigen: string){
    var retorno: EBMHeaderRequest = {
        Operacion:     l_Operacion,
        ParametroList: l_ParametroList,
        SeguridadList: l_SeguridadList,
        SistemaOrigen: l_SistemaOrigen
    }

    return retorno;
}

export interface ParametroList {
    ParametroItem: any[];
}

export function builtParametroList( l_ParametroItem: []){
    var retorno = {ParametroItem: l_ParametroItem};

    return retorno;
}

export interface SeguridadList {
    SeguridadItem: SeguridadItem[];
}

export function builtSeguridadList( l_SeguridadItem: SeguridadItem[]){
    var retorno: SeguridadList ={SeguridadItem: l_SeguridadItem};

    return retorno;
}

export interface SeguridadItem {
    Password:           string;
    SistemaAAutenticar: string;
    Username:           string;
}

export function builtSeguridadItem( Password: string, SistemaAAutenticar: string, Username: string){
    var retorno: SeguridadItem = {
        Password:           Password,
        SistemaAAutenticar: SistemaAAutenticar,
        Username:           Username
    }

    return retorno;
}



//Response  


export interface ConsultaHistorialControl_salida {
    ConsultaSolicitudDeServicioProcessResponse: ConsultaSolicitudDeServicioProcessResponse;
}

export interface ConsultaSolicitudDeServicioProcessResponse {
    resultado:                  string;
    resultadodesc:              string;
    DetalleSolicitudDeServicio: DetalleSolicitudDeServicio[];
}

export interface DetalleSolicitudDeServicio {
    NumeroDeSolicitud:  string;
    Area:               string;
    SubAarea:           string;
    Comentario:         string;
    TarjetaInteligente: string;
    FechaCreacion:      string;
    Estatus:            string;
}

export type ConsultaHistorialControl_Respuesta = EncabezadoRespuestaInterna & ConsultaHistorialControl_salida;